import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_MAM_OBJECTS_LIST_WITH_TOTAL = gql`
  query getMamObjectsListWithTotal($type: [String], $search: String, $isPublic: Boolean, $uploadedBy: String, $tags: [String], $sort: String, $offset: Int, $limit: Int) {
    getMamObjectsListWithTotal(type: $type, search: $search, isPublic: $isPublic, uploadedBy: $uploadedBy, tags: $tags, sort: $sort, offset: $offset, limit: $limit) {
      mamObjects {
        assetSlugName
        isPublic
        url
        fileExtension
        type
        tags
        fileSize
        uploadedBy
        createdAt
        fileReadableName {
          en
          es
          ca
          pt
        }
        description {
          en
          es
          ca
          pt
        }
      }
      total
      uploaders
      allTags
    }
  }
`;

const getMamObjectsListWithTotal = async (variables = {}) => {
  try {
    const result = await client.query({
      query: GET_MAM_OBJECTS_LIST_WITH_TOTAL,
      variables,
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
    });
    const { data: { getMamObjectsListWithTotal: mamData } } = result;
    if (mamData) return mamData;
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getMamObjectsListWithTotal = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getMamObjectsListWithTotal Error: ${error}`);
    return null;
  }
};

export default getMamObjectsListWithTotal;
